
import BluetoothRectangle from "../../../assets/outline/BluetoothRectangle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BluetoothRectangleIcon({ className, dataTestid = "BluetoothRectangleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BluetoothRectangle data-testid={dataTestid} className={classes} {...rest} />
  );
}
